import { Component, OnInit } from '@angular/core';
import { PartnerQuery, Partner, PartnerService, PartnerPendingService, PartnerPending, PartnerPendingQuery } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';
@Component({
  selector: 'fgb-partner-list',
  templateUrl: './partner-list.component.html',
  styleUrls: ['./partner-list.component.scss'],
})
export class PartnerListComponent implements OnInit {
  populations = Populations;
  constructor(
    private pendingQuery: PartnerPendingQuery,
    private partnerQuery: PartnerQuery,
    private partnerService: PartnerService,
    private pendingService: PartnerPendingService
  ) {}
  approvedPartners$: Observable<Partner[]>;
  pendingPartners$: Observable<PartnerPending[]>;
  partnerName: String;
  partnerEmail: String;

  ngOnInit() {
    this.approvedPartners$ = this.partnerQuery.selectAll();
    this.pendingPartners$ = this.pendingQuery.selectAll();
  }

  delete(id: number) {
    firstValueFrom(this.partnerService.remove(id));
  }

  deletePending(ticketKey: string) {
    firstValueFrom(this.pendingService.remove(ticketKey));
  }
  selectPartner(FullName: string, Email: string) {
    this.partnerName = FullName;
    this.partnerEmail = Email;
  }
}
